import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AlertTriangle, Download, Printer } from "lucide-react";
import { downloadBackup, hasUnsavedPlan, markSaved } from "@/lib/planBackup";

// Banner on plan pages + browser "leave site?" warning while the plan has changes not yet downloaded or printed.
export function PlanSaveReminder() {
  const { pathname } = useLocation();
  const [dirty, setDirty] = useState(hasUnsavedPlan);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const check = () => setDirty(hasUnsavedPlan());
    const printed = () => markSaved();
    window.addEventListener("ukready:plan-saved", check);
    window.addEventListener("afterprint", printed);
    const t = setInterval(check, 3000);
    return () => { window.removeEventListener("ukready:plan-saved", check); window.removeEventListener("afterprint", printed); clearInterval(t); };
  }, []);
  useEffect(() => {
    if (!dirty) return undefined;
    const warn = (e) => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [dirty]);
  if (!dirty || hidden || !pathname.startsWith("/my-plan") || pathname.startsWith("/my-plan/print")) return null;
  return (
    <div role="status" data-testid="plan-save-reminder" className="no-print sticky top-0 z-40 border-b border-amber-300 bg-amber-50">
      <div className="container-x flex flex-wrap items-center gap-3 py-2 text-sm text-amber-950">
        <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="font-semibold">Your plan clears when you close this tab.</span>
        <span>Save a copy before you go.</span>
        <button onClick={downloadBackup} data-testid="reminder-download" className="inline-flex items-center gap-1 rounded bg-navy px-3 py-1 text-xs font-bold text-white"><Download className="h-3.5 w-3.5" /> Download backup</button>
        <a href="/my-plan/print" data-testid="reminder-print" className="inline-flex items-center gap-1 rounded border border-navy px-3 py-1 text-xs font-bold text-navy"><Printer className="h-3.5 w-3.5" /> Print</a>
        <button onClick={() => setHidden(true)} data-testid="reminder-dismiss" className="ml-auto text-xs font-semibold underline">Hide for now</button>
      </div>
    </div>
  );
}
